export const footerText = `BE Analytic Solutions, B131/A, Devasandra Industrial Estate, Whitefield Rd, 
  Mahadevapura, Bangalore -560048, India. Ph: 91-80-95000449, Fax: 917838593998, 
  sales@beanalytic.com, www.beanalytic.com `;

export const reportDisclaimerText = `
In making any use of this test report you are expressly agreeing to the disclaimers 
and notices below: BE Analytic Testing procedures were performed to the best of our ability. 
All data and test results presented in your report document the equipment's characteristics which 
were analysed and/or calculated at that specific point in time. 
All test data and results presented are pertaining only to the DUT/SAMPLE, 
which was received for the test with identity mentioned in the below report. 
This particular test does not require any statement of conformity or opinion/interpretation. 

`;

export const reportDisclaimerNoteText = `
NOTE: This report shall not be reproduced except in full without approval of the laboratory 
can provide assurance that parts of a report are not taken out of context.
`;

export const preparedByName = "Rohit";
export const preparedByDesignation = "Lab Manager";

export const reviewedByName = "Chathura PV";
export const reviewedByDesignation = "Dy.Q.M";

export const authorizedByName = "Anil Kumar Ammina";
export const authorizedByDesignation = "Q.M.";
